import { NestingRunView } from "../api/nestingContract";
import {
  Layout,
  MaterialLayout,
  Optimization,
  OptimizationTypeSchema,
  SheetNestingOptimizationMetadata,
} from "../types";
import { computeNestingUnitMaterialCosts } from "./computeNestingUnitMaterialCosts";
import { getNestedLineQuantity } from "./getNestedLineQuantity";

export type OptimizedMaterialCosts = ReadonlyMap<string, number>;

export const NO_OPTIMIZED_MATERIAL_COSTS: OptimizedMaterialCosts = new Map();

export type SheetNestingOptimizationForComputing = Optimization & {
  sheetNestingOptimizationMetadata:
    | (SheetNestingOptimizationMetadata & {
        layout: (Layout & { materialLayout: MaterialLayout | null }) | null;
        nestingRun: Pick<NestingRunView, "sheetsUsed" | "items"> | null;
      })
    | null;
  quoteRequestLines: {
    id: string;
    quantity: number;
    part: { quantityInAssembly: number | null };
  }[];
};

export const computeOptimizedMaterialCosts = (
  optimizations: SheetNestingOptimizationForComputing[],
): OptimizedMaterialCosts => {
  const optimizedMaterialCosts = new Map<string, number>();

  for (const optimization of optimizations) {
    const metadata = optimization.sheetNestingOptimizationMetadata;
    const isAppliedSheetNestingOptimization =
      optimization.enabled && optimization.type === OptimizationTypeSchema.enum.SHEET_NESTING;
    if (!isAppliedSheetNestingOptimization || !metadata?.layout || !metadata.nestingRun) {
      continue;
    }

    const unitCosts = computeNestingUnitMaterialCosts({
      nestingRun: metadata.nestingRun,
      layout: metadata.layout,
      lines: optimization.quoteRequestLines.map((line) => ({
        id: line.id,
        quantity: getNestedLineQuantity(line),
      })),
    });
    unitCosts.forEach((unitCost, lineId) => optimizedMaterialCosts.set(lineId, unitCost));
  }

  return optimizedMaterialCosts;
};
